export default "__VITE_ASSET__CzLyyctZ__"